module.exports = __webpack_public_path__ + "static/img/a612.7805a3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a612.png
// module id = 4jcR
// module chunks = 73